interface Props {
  percentage: number;
}
const ProgressBar = ({ percentage }: Props) => {
  return <></>;
};

export default ProgressBar;
